import { useContext, useEffect, useState } from "react";
import { fetchData } from "../../utils/fetch";
import { LanguageContext } from "../../utils/lang_provider";
import { Divider, Flex, message } from "antd";
import ArticleComponent from "./article_component";

export default function CatalogArticles( {type} ) {
    const [ articles, setArticles ] = useState([]);
    const { language } = useContext(LanguageContext);

    useEffect(() => {
        async function loadArticles() {
            try {
                const data = await fetchData(`front/articles/${type}`, language);
                setArticles(data);
                console.log(data);
            } catch (error) {
                message.error("Error getting articles.")
            }
        }
        loadArticles();
    }, [type, language]);

    return (
        <Flex vertical>
            {articles.map((article) => (
                <>
                    <ArticleComponent article={article} type={type}></ArticleComponent>
                    <Divider></Divider>
                </>
            ))}
        </Flex>
    )
}
